export default __webpack_public_path__ + "static/media/venmo.7980557f.svg";